// Constants
// Utilities
import { createContext, useContext } from "react";
const noOpTracker = {
    startInteraction: ()=>undefined,
    completeInteractions: ()=>undefined,
    cancelInteractions: ()=>undefined
};
/** Supplied by the application shell. Trees without the shell safely record nothing. */ export const InteractionTrackerContext = /*#__PURE__*/ createContext(noOpTracker);
/** Returns interaction start and explicit completion capabilities. */ export function useInteractionTracker() {
    return useContext(InteractionTrackerContext);
}
